import { render, staticRenderFns } from "./OperatePerm.vue?vue&type=template&id=62028431&"
import script from "./OperatePerm.vue?vue&type=script&lang=js&"
export * from "./OperatePerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports